import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["page", "disabled"];
import React, { useContext } from 'react';
import { PageNavigatorContext } from "../PageNavigator";
import { TextBase } from "../../internal/TextBase";
import { Button } from './Button';
export var Item = function Item(_ref) {
  var page = _ref.page,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(PageNavigatorContext),
      activePage = _useContext.activePage,
      onChangePage = _useContext.onChangePage;

  var isActive = page === activePage;

  var handleClick = function handleClick() {
    return onChangePage(page);
  };

  return /*#__PURE__*/React.createElement(Button, _extends({}, restProps, {
    onClick: handleClick,
    disabled: disabled,
    active: isActive
  }), /*#__PURE__*/React.createElement(TextBase, {
    size: "l"
  }, page));
};